<template>
	<BaseCatalogSort :sort-options="['most_purchased_and_newest', 'new', 'old', 'cheaper', 'expensive']" v-slot="{items: sortOptions, selected, onSort}">
		<div class="sort c-sort">
			<select @change="onSort">
				<option :value="sort" v-for="sort in sortOptions" :selected="sort == selected" :key="sort"><BaseCmsLabel :code="'ordering_'+sort" /></option>
			</select>
		</div>
	</BaseCatalogSort>
</template>